import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@cortex/web-design-system/components/ui/Button';

/** @graph-connects none */
interface LoadStateProps {
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}

/**
 * 読み込み中・失敗の表示（失敗したらもう一度取れるようにする）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 組織課題の画面で読み込み中・読み込み失敗を出し、失敗時は読み直せるようにする
 * @graph-connects none
 */
export function LoadState({ isLoading, isError, onRetry }: LoadStateProps): ReactNode {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <p className="text-sm text-[var(--color-text-muted)]">{t('orgIssues.common.loading')}</p>
    );
  }
  if (!isError) return null;
  return (
    <div className="flex items-center gap-2 text-sm text-[var(--color-error)]">
      {t('orgIssues.common.loadError')}
      <Button type="button" size="sm" variant="ghost" onClick={onRetry}>
        {t('orgIssues.common.retry')}
      </Button>
    </div>
  );
}
